export enum ToastActions {
  CLICK_LINK,
}
